import { createContext } from 'react';
import { LiliTransaction } from '../../TransactionsFacelift/types/lili-transaction';
import { IInvoice, IUncategorizedTransactions, IBill } from '../../../types';
import { ProfitChartData } from '../types/profitChartData';
import { ExpensesChartData } from '../types/expensesChartData';
import { IncomeChartData } from '../types/incomeChartData';

export interface IChartFilterItem {
  endDate: string;
  longTitle: string;
  periodType: string;
  shortTitle: string;
  startDate: string;
}
export interface IChartFilterSectionItem {
  items: IChartFilterItem[];
  title: string;
}

export interface IChartFilter {
  sections: IChartFilterSectionItem[];
}

export interface IDashboardContext {
  latestTransactions: LiliTransaction[];
  uncategorizedTransactions: {
    expenseTransactionsList: IUncategorizedTransactions | null,
    incomeTransactionsList: IUncategorizedTransactions | null
  };
  lastInvoices: IInvoice[];
  lastBills: IBill[];
  totalBillsDueAmount: number;
  totalInvoicedAmount: number;
  totalOutstandingInvoiceAmount: number;
  profitChartData: ProfitChartData;
  expensesChartData: ExpensesChartData;
  incomeChartData: IncomeChartData;
  chartFilters: IChartFilter;
}

export const DashboardContext = createContext<IDashboardContext>({
  latestTransactions: [],
  uncategorizedTransactions: {
    expenseTransactionsList: null,
    incomeTransactionsList: null,
  },
  lastInvoices: [],
  lastBills: [],
  totalBillsDueAmount: 0,
  totalInvoicedAmount: 0,
  totalOutstandingInvoiceAmount: 0,
  profitChartData: {
    periodType: '',
    periodName: '',
    totalItems: [],
    profitChartItems: [],
    chartSummaryData: {
      total: 0,
      positiveTrend: false,
      incrementSinceLastPeriod: false,

    },
  },
  expensesChartData: {
    periodType: '',
    periodName: '',
    categoriesItems: [],
    segmentedItems: [],
    chartSummaryData: {
      total: 0,
      positiveTrend: false,
      incrementSinceLastPeriod: false,
    },
  },
  incomeChartData: {
    periodType: '',
    periodName: '',
    categoriesItems: [],
    segmentedItems: [],
    chartSummaryData: {
      total: 0,
      positiveTrend: false,
      incrementSinceLastPeriod: false,
    },
  },
  chartFilters: {
    sections: [
      {
        items: [
          {
            endDate: '',
            longTitle: '',
            periodType: '',
            shortTitle: '',
            startDate: '',
          },
        ],
        title: '',
      },
    ],
  },
});
